<template>
  <content-view v-if="previewItem" :contentItem="previewItem" />
</template>

<script setup>
defineProps({ previewItem: Object });
</script>

<style scoped>
#preview-app-bar {
  background-color: var(--main-color);
}

.preview-content {
  height: 100%;
}
</style>
